import { ACTIVE_MATCH_MODE, FIELD, type Ball } from "@golazo/shared";
import { clone, vec } from "../core/math.js";

export function createBall(): Ball {
  const pos = vec(FIELD.WIDTH / 2, FIELD.HEIGHT / 2);
  return {
    pos,
    prevPos: clone(pos),
    vel: vec(),
    radius: ACTIVE_MATCH_MODE.physics.ballRadius,
    spin: 0,
    topSpin: 0,
    loft: 0,
    prevLoft: 0,
    loftVel: 0,
    unstoppable: false,
  };
}

/** Devuelve el balon al centro, parado. Saque de centro. */
export function resetBall(ball: Ball): void {
  ball.pos.x = FIELD.WIDTH / 2;
  ball.pos.y = FIELD.HEIGHT / 2;
  ball.prevPos.x = ball.pos.x;
  ball.prevPos.y = ball.pos.y;
  ball.vel.x = 0;
  ball.vel.y = 0;
  ball.spin = 0;
  ball.topSpin = 0;
  ball.loft = 0;
  ball.prevLoft = 0;
  ball.loftVel = 0;
  ball.unstoppable = false;
}
